import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Checkbox, Flex, Input, Form, message, Space, Popover } from "antd";
import { login, loginByPhone, sendSmsCode } from '@/apis/login';
import { DataContext } from "@/context";
// import LOGIN_LOGO from "@/assets/images/login/login_logo.png";
import QR_CODE from "@/assets/images/login/qrcode.jpg";
import EyePng from "@/assets/images/login/eye.png";
import HideEyePng from "@/assets/images/login/hide_eye.png";
// import { recordClickType } from "@/apis/record";
// import { clickTypeMapper } from '@/config/constent';
import { usePostHog } from 'posthog-js/react';

const LOGIN_LOGO = 'https://ps-cdn.cemeta.cn/configs/frontend/20250917/3.png'
interface Props {
  open: Boolean;
  propsSetOpen?: (value: boolean) => any;
  propsSetIsLogin?: (value: boolean) => any;
}

const formItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
};

const Login: React.FC<Props> = (props: Props) => {
  const { open, propsSetOpen, propsSetIsLogin } = props;
  const timer = useRef(0);
  const {
    userInfo,
    setContextValue
} = useContext(DataContext);

  const [messageApi, contextHolder] = message.useMessage();

  const [form] = Form.useForm();
  const [submittable, setSubmittable] = React.useState(true);
  const [loginType, setLoginType] = useState<'phone_number' | 'email'>('email');
  const [isPassword, setIsPassword] = useState(true)
  const [countDown, setCountDown] = useState(60);
  const [agree, setAgree] = useState(false);

  const isPhoneLogin = loginType === 'phone_number';
  const isEmailLogin = loginType === 'email';

  const values = Form.useWatch([], form);

  const posthog = usePostHog();

  useEffect(() => {
    if (!userInfo?.user_id && open) {
      const userForm = localStorage.getItem('userLogin')

      if (userForm) {
        form.setFieldsValue(JSON.parse(userForm))
      }
    }
}, [open, userInfo?.user_id])

  useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then((res) => {
        setSubmittable(true)
      })
      .catch((err) => {
        // console.log(err)
        if (err?.errorFields?.length) {
          setSubmittable(false)
        }
      });
  }, [form, values]);

  const jumpRegister = (e) => {
    e.preventDefault();
    propsSetIsLogin?.(false);
  };

  const handleLogin = async () => {
    const {...values} = await form.getFieldsValue();
    if (!agree) {
      messageApi.open({
        type: 'warning',
        content: '请同意用户协议与隐私政策',
      });
      return
    }
    // recordClickType({
    //   event_name: clickTypeMapper.CEMETA_LOGIN
    // }).catch((err) => {
    //   console.error('err', err)
    // })
    posthog?.capture('haohui_login', {
      type: 'pc',
      info: navigator?.userAgent
    });

    // 看后面的接口是否是同一个，暂定是同一个
    if (isPhoneLogin) {
      values.email = undefined;
      await loginByPhone({ ...values, country_code: '+86', code_type: 'login'  })
        .then((res) => {
          values?.remember
            ? localStorage.setItem('userLogin', JSON.stringify(values))
            : localStorage.removeItem('userLogin')
          if (res) {
            localStorage.setItem('userInfo', JSON.stringify(res))
            setContextValue((contextValue) => ({
              ...contextValue,
              userInfo: {
                ...res,
                user_id: '' + res?.user_id + '_' + new Date().getTime(),
              }
            }))
            messageApi.open({
              type: 'success',
              content: '登录成功',
            });

            propsSetOpen?.(false);
          }
        }).catch(err => {
        console.error(err)
        messageApi.open({
          type: 'error',
          content: err,
        });
      })
    } else {
      values.phone_number = undefined;
      await login(values)
      .then((res) => {
        values?.remember 
          ? localStorage.setItem('userLogin', JSON.stringify(values))
          : localStorage.removeItem('userLogin')
        if (res) {
          localStorage.setItem('userInfo', JSON.stringify(res))
          setContextValue((contextValue) => ({
            ...contextValue,
            userInfo: {
              ...res, 
              user_id: '' + res?.user_id + '_' + new Date().getTime(),
            }
          }))
          messageApi.open({
            type: 'success',
            content: '登录成功',
          });

          propsSetOpen?.(false);
        }
      }).catch(err => {
        console.error(err)
        messageApi.open({
          type: 'error',
          content: err,
        });
      })
    }
   
  }

  const timeCountDown = () => {
    setCountDown(countDown - 1)
  }

  useEffect(() => {
    if (countDown !== 60) {
      timer.current = window.setTimeout(() => {
        if (countDown <= 0) {
          timer.current && clearTimeout(timer.current)
          setCountDown(60)
        } else {
          setCountDown(countDown - 1)
        }
      }, 1000)
    }
    return () => {
      timer.current && clearInterval(timer.current)
    }
  }, [countDown])

  const handleVerifyCode = () => {
    if (countDown !== 60) {
      messageApi.open({
        type: 'warning',
        content: `${countDown} + '秒后再试'`,
      });
      return
    }
    form.validateFields(['phone_number'])
      .then(async () => {
        await sendSmsCode({ phone_number: values.phone_number, country_code: '+86', code_type: 'login' })
          .then(() => {
            messageApi.open({
              type: 'success',
             content: '手机验证码已发送，请注意查收',
            });
            timeCountDown()
          })
          .catch(err => {
            console.error(err)
            messageApi.open({
              type: 'error',
              content: err,
            });
          })
      })
      .catch((errorInfo) => {
        console.error('errorInfo', errorInfo)
      })
  }

  const renderContent = (
    <div className='register-qrcode-alert'>
        <span className='register-qrcode-title'>{'扫码添加客服'}</span>
        <span className='register-qrcode-text' style={{ marginBottom: '12px' }}>{'获取注册邀请码，解锁更多使用权益'}</span>
        <img className='register-qrcode-image' src={QR_CODE} alt="qr-code" />
    </div>
  )

  const SECRET_INFO = 'https://mi8elatzm1x.feishu.cn/docx/PazXdOKmSordWGxxejLc2joqnIh?from=from_copylink';
  const USER_INFO = 'https://mi8elatzm1x.feishu.cn/docx/IyM2dSZKpovGFaxtws9ckeJFnSf?from=from_copylink';

  const handleJumpUser = (e) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(USER_INFO, '_blank');
  }

  const handleJumpSecret = (e) => {
    e.stopPropagation();
    e.preventDefault();
    
    window.open(SECRET_INFO, '_blank');
  }

  return (
    <>
      {contextHolder}
      <Form
          key={new Date().toDateString()}
          className="header-model-form"
          {...formItemLayout}
          form={form}
          variant={'filled'}
          size={'large'}
          initialValues={{
            email: '',
            password: '',
          }}
      >
        <Form.Item style={{ marginBottom: '24px' }}>
          <div className="header-model-form-item-title">
            <img style={{ width: '140px', height: '58px' }} src={LOGIN_LOGO} alt="login-logo" />
            <div className="header-model-form-item-title-text-container">
              <div className={`header-model-form-item-title-text ${isEmailLogin ? 'header-model-form-item-title-active' : ''}`}>
                <span
                  onClick={() => {
                    setLoginType('email')
                    setIsPassword(true)
                    form.setFieldsValue({
                      email: undefined,
                      phone_number: undefined,
                      password: undefined,
                    })
                  }}
                >
                  邮箱登录
                </span>
              </div>
              <div className="header-model-form-item-divider"></div>
              <div className={`header-model-form-item-title-text ${isPhoneLogin ? 'header-model-form-item-title-active' : ''}`}>
                <span
                  onClick={() => {
                    setLoginType('phone_number')
                    setIsPassword(true)
                    form.setFieldsValue({
                      email: undefined,
                      phone_number: undefined,
                      password: undefined,
                    })
                  }}
                >
                  手机号登录
                </span>
              </div>
            </div>
          </div>
        </Form.Item>
        {isEmailLogin ? (
          <Form.Item
          style={{ marginBottom: '12px' }}
          // label="Input"
          validateFirst
          name="email"
          rules={[
            {
              required: true,
              message: '请输入邮箱',
            },
            {
              pattern: /^[\w.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              message: '请输入正确的邮箱'
            }
          ]}
        >
          <Input style={{ height: '48px' }} placeholder='请输入邮箱' autoComplete="new-password" />
        </Form.Item>
        ): null}
        {isPhoneLogin ? (
          <Form.Item
            style={{ marginBottom: '12px' }}
            // label="Input"
            validateFirst
            name="phone_number"
            rules={[
              {
                required: true,
                message: '请输入手机号',
              },
              {
                pattern: /^1[1-9]\d{9}$/,
                message: '请输入正确的手机号'
              }
            ]}
          >
            <Input style={{ height: '48px' }} placeholder='请输入手机号' autoComplete="new-password" />
          </Form.Item>
        ) : null}
       {isPassword ?( 
        <Form.Item
          style={{ marginBottom: '12px' }}
          // label="Password"
          name="password"
          validateFirst
          rules={[
            {
              required: true,
              message: '请输入密码',
            },
            {
              pattern: /^(?=.*\d)(?=.*[a-zA-Z]).*$/,
              message: '密码需要包含数字和英文'
            },
            {
              min: 8,
              message: '密码长度最少8个字符'
            },
            {
              max: 20,
              message: '密码长度不超过20个字符'
            },
          ]}
        >
          <Input.Password
            placeholder='请输入密码'
            autoComplete="new-password"
            style={{ height: '48px' }}
            iconRender={(visible) =>
              visible ? (
                <img className="password-icon" src={EyePng} alt="eye" />
              ) : (
                <img className="password-icon" src={HideEyePng} alt="hide-eye" />
              )}
            />
        </Form.Item>
        ): (
          <Form.Item
          className="register-form-item-verify-code"
          style={{ marginBottom: '12px' }}
          name="verify_code"
          rules={[
            {
              required: true,
              message: '请输入手机验证码',
            },
            {
              len: 6,
              message: '请输入6位手机验证码'
            }
          ]}
        >
          <Space.Compact
            style={{
              width: '100%',
            }}
          >
            <Input placeholder='请输入手机验证码' autoComplete="new-password" style={{ height: '48px' }} />
            {countDown === 60
                ? <Button color="primary" variant="text" style={{ height: '48px' }} onClick={handleVerifyCode}>获取验证码</Button>
                : <Button color="primary" variant="text" disabled style={{ height: '48px' }}>{countDown + '(s)后再试'}</Button>}
            
          </Space.Compact>
          
        </Form.Item>
        )}
        {/* <Form.Item>
          <Flex justify="end" align="center">
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox><span style={{ color: '#666666' }}>保存密码</span></Checkbox>
            </Form.Item>
          </Flex>
        </Form.Item> */}
        <Flex justify={isPhoneLogin ? 'space-between' : 'end'} align="center" className="forgot-password">
          {isPhoneLogin ? (
            isPassword ? (
              <div
                className="is-password-change"
                onClick={() => {
                  setIsPassword(false)
                  form.setFieldsValue({
                    email: undefined,
                    password: undefined,
                    verify_code: undefined,
                  })
                }}
              >
                短信验证码登录
              </div>
            ) : (
              <div className="is-password-change"
                onClick={() => {
                  setIsPassword(true)
                  form.setFieldsValue({
                    email: undefined,
                    password: undefined,
                    verify_code: undefined,
                  })
                }}
              >
                密码登录
              </div>
            )
          ) : null}
          {isPassword ? (
            <a href="">忘记密码？</a>
          ) : (
            <Popover className="cant-hold-code" content={renderContent} style={{ cursor: 'pointer' }} trigger="click">
              <div>收不到验证码？</div>
            </Popover>
          )}
        </Flex>
        <div className="header-model-footer">
          <Button type="primary" block disabled={!submittable || !agree} onClick={handleLogin}>
            登录
          </Button>
          <Form.Item>
          <Flex justify="start" align="center">
            <Checkbox checked={agree} onChange={(e) => setAgree(e.target.checked)}><span className="agree-text">已阅读并同意 <span style={{ color: "#191919" }} onClick={handleJumpUser}>用户协议</span> 与 <span style={{ color: "#191919" }} onClick={handleJumpSecret}>隐私政策</span></span></Checkbox>
          </Flex>
          </Form.Item>
          <div className="header-model-footer-sign" style={{ marginBottom: '10px' }}>
            <span style={{ color: '#888888' }}>还没有账号？</span>
            <span style={{ borderBottom: '1px solid #376BFF' }}>
              <a href="" style={{ color: '#376BFF' }} onClick={jumpRegister}>去注册</a>
            </span>
          </div>
        </div>
      </Form>
    </>
  );
};

export default Login;
